import React from 'react';
import { Typography, Button, Paper } from '@mui/material';
import { ThumbUp as ApproveIcon, ThumbDown as RejectIcon } from '@mui/icons-material';

const BulkActionBar = ({ selectedItems, onApprove, onReject, onDeselect }) => {
  if (selectedItems.length === 0) return null;

  return (
    <Paper
      sx={{
        position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
        p: 2, display: 'flex', gap: 2, alignItems: 'center', zIndex: 1000, boxShadow: 3,
      }}
    >
      <Typography variant="body1">{selectedItems.length} item(s) selected</Typography>
      <Button variant="contained" color="success" startIcon={<ApproveIcon />} onClick={onApprove}>
        Approve All
      </Button>
      <Button variant="contained" color="error" startIcon={<RejectIcon />} onClick={onReject}>
        Reject All
      </Button>
      <Button variant="outlined" onClick={onDeselect}>Deselect All</Button>
    </Paper>
  );
};

export default BulkActionBar;
